import { SiteContextModeEnum } from '@/enums/SiteContextModeEnum'
import { resolveTenantById } from '@/lib/tenant/resolve-tenant'

export const getTenantMarkets = (tenantId: string): SiteContextModeEnum[] => {
  const tenant = resolveTenantById(tenantId)

  return [tenant.features.b2c && SiteContextModeEnum.b2c, tenant.features.b2b && SiteContextModeEnum.b2b].filter(
    Boolean
  ) as SiteContextModeEnum[]
}
